import { Button } from "antd";
import { Image } from "antd-mobile";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetNetLossLevelProgress } from "../../hooks/comissionreport.hooks";
import User from "../../images/User";
import TitleContainer from "../ComissionBetAmountRebate/components/TitleContainer";
import Progress from "../Progress";
import ShadowText from "./components/ShadowText";
import styles from "./styles.module.scss";
const ComissionNetLoss = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: netlossProgress } = useGetNetLossLevelProgress({});
  const [items, setItems] = useState(Array(5).fill({ active: false }));
  useEffect(() => {
    console.debug("netlossProgress", netlossProgress);
    if (!netlossProgress) return;
    // if (netlossProgress?.current_valid_count <= 0) return;
    const _progress = items.map((item, index) => {
      if (index < netlossProgress?.current_valid_count) return { active: true };
      return { active: false };
    });
    setItems(_progress);
  }, [netlossProgress]);

  const handleOpenPromote = () => {
    navigate("/promote");
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Image
          className={styles.backgroundImage}
          src={"/images/comission/default/netloss-header.png"}
        />
        <ShadowText hidePlaceholder>
          <div className={styles.title1}>
            <Trans i18nKey={"mobile.comission.netloss"} />
          </div>
          <div className={styles.title2}>
            <Trans
              i18nKey={"comission.netloss.subtitle"}
              components={{
                span: <span />,
              }}
            />
          </div>
        </ShadowText>
      </div>
      <div className={styles.card}>
        <div className={styles.contentDesc}>
          <div className={styles.levelContainer}>
            <div className={styles.progressWrapper}>
              <Image
                src={
                  netlossProgress?.is_max_level === false
                    ? "/images/comission/default/line-unlock.png"
                    : "/images/comission/default/line-locked.png"
                }
                className={styles.image}
              />
              {netlossProgress?.is_max_level ? null : (
                <>
                  <div className={styles.currentLevelWrapper}>
                    <div className={styles.desc}>{t("comission.netloss.currentlevel")}</div>
                    <ShadowText
                      shadowClassName={styles.lockedLevelShadow}
                      contentClassName={styles.lockedLevel}
                    >
                      {netlossProgress?.current_level_name}
                    </ShadowText>
                  </div>
                  <div className={styles.nextLevelWrapper}>
                    <div className={styles.desc}>{t("comission.netloss.nextlevel")}</div>
                    <div className={styles.lockWrapper}>
                      <img
                        alt={"next-level"}
                        src={"/images/comission/default/locker.png"}
                        className={styles.lockImage}
                      />
                      <ShadowText
                        shadowClassName={styles.lockedLevelShadow}
                        contentClassName={styles.lockedLevel}
                      >
                        {netlossProgress?.next_level_name}
                      </ShadowText>
                    </div>
                  </div>
                </>
              )}
            </div>
            {netlossProgress?.is_max_level ? (
              <div className={styles.wrapper}>
                <ShadowText
                  shadowClassName={styles.lockedLevelShadow}
                  contentClassName={styles.lockedLevel}
                >
                  {netlossProgress?.current_level_name}
                </ShadowText>
              </div>
            ) : null}
          </div>
          <div className={styles.descContainer}>
            <ShadowText>
              <div className={styles.title1}>
                <Trans
                  i18nKey={
                    netlossProgress?.is_max_level
                      ? "comission.netloss.maxLevel"
                      : "comission.netloss.desc"
                  }
                />
              </div>
            </ShadowText>
          </div>
          {netlossProgress?.is_max_level === false ? (
            <div className={styles.progressContainer}>
              <div className={styles.iconContainer}>
                {items.map((item, index) => {
                  console.debug(item, item, item.active === true);
                  return (
                    <div key={index}>
                      <User
                        uid={index}
                        startColor={
                          item.active === true
                            ? "var(--netloss-icon-start-active)"
                            : "var(--netloss-icon-start-inactive)"
                        }
                        endColor={
                          item.active === true
                            ? "var(--netloss-icon-end-active)"
                            : "var(--netloss-icon-end-inactive)"
                        }
                        className={styles.icon}
                      />
                    </div>
                  );
                })}
              </div>
              <Progress
                percent={
                  ((netlossProgress?.current_valid_count || 0) /
                    (netlossProgress?.required_count || 1)) *
                  100
                }
              />
              <div className={styles.progressText}>
                {t("comission.netloss.inviteleft", {
                  current: netlossProgress?.current_valid_count || 0,
                  max: netlossProgress?.required_count || 0,
                })}
              </div>
            </div>
          ) : null}
          <Button
            onClick={handleOpenPromote}
            shape={"round"}
            className={styles.button}
            block={true}
          >
            {t("comission.netloss.invite.button")}
          </Button>
        </div>
      </div>
      <div className={styles.card}>
        <TitleContainer title={t("comission.netloss.tnc.title")} />
        <div className={styles.contentDesc}>
          <Trans
            i18nKey={"comission.netloss.tnc.desc"}
            components={{
              ol: <ol />,
              li: <li />,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ComissionNetLoss;
